import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { testimonials } from "../data/landing";
export function Testimonials() {
  return <Section tone="navy" cta="Start Organizing My Clinical Library" data-id="element-288" data-mp="3fz5s296i04m2">
      <SectionHeading eyebrow="What practitioners are saying" title="A More Organized Way to Study and Prepare" data-id="element-289" data-mp="3b0knxyo4l0sc" />

      <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-290" data-mp="36z9469rxn9s2">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-panel p-6 ring-1 ring-line sm:p-7" data-id="element-291" data-mp="31zmsw5vo03lw">
            <div className="flex items-center gap-4" data-id="element-292" data-mp="2x1urml94r551">
              <img src={t.image} alt={`Portrait of ${t.name}`} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold sm:h-[4.5rem] sm:w-[4.5rem]" loading="lazy" data-id="element-293" data-mp="2x2mkhobceorm" />
              <figcaption data-id="element-294" data-mp="qbn3it5a96oc">
                <p className="text-base font-bold text-cream sm:text-lg" data-id="element-295" data-mp="q896m0fe1poa">{t.name}</p>
                <p className="text-sm text-muted" data-id="element-296" data-mp="h4n5afz667d1">{t.role}</p>
                <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-297" data-mp="m5b3blltfogr">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-298" data-mp="79v83d9i1mis" data-mpi={i} />)}
                </div>
              </figcaption>
            </div>
            <blockquote className="relative mt-5 flex-1" data-id="element-299" data-mp="zwxz7kbuiuz0">
              <QuoteIcon className="absolute -left-1 -top-1 h-6 w-6 text-gold/30" aria-hidden="true" data-id="element-300" data-mp="14w2dgpdmniw7" />
              <p className="pl-6 text-base leading-relaxed text-cream" data-id="element-301" data-mp="q7ejgnjfjh8d">{t.quote}</p>
            </blockquote>
          </figure>)}
      </div>

      <p className="mt-6 text-center text-xs text-muted/80" data-id="element-302" data-mp="v3mrzi34gc6k">
        Individual experiences. HOF CLINICAL BLUEPRINT™ is an educational resource and does not guarantee clinical
        outcomes.
      </p>
    </Section>;
}